import { XMarkIcon } from '@heroicons/react/24/solid';
import { AssetData } from '@superfunnel/types';
import Button from '@superfunnel/ui-core/v2/Button';
import { Dialog, DialogContent } from '@superfunnel/ui-core/v2/Dialog';
import { ImageViewer } from './ImageViewer';

interface Props {
  open: boolean;
  onClose: () => void;
  images: AssetData[];
}

export const ImageViewerModal = ({ images, open, onClose }: Props) => {
  return (
    <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
      <DialogContent
        className="max-h-screen max-w-4xl p-0"
        style={{ width: '900px', height: '600px' }}
        showCloseButton={false}
      >
        <ImageViewer images={images} className="h-full" />
        <Button
          variant="ghost"
          size="icon"
          className="absolute top-4 right-4"
          onClick={() => onClose()}
        >
          <XMarkIcon className="h-6 w-6" />
        </Button>
      </DialogContent>
    </Dialog>
  );
};
